var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F2D3D",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.5 11c0-4.478 0-6.718 1.391-8.109S6.521 1.5 11 1.5c4.478 0 6.718 0 8.109 1.391S20.5 6.521 20.5 11c0 4.478 0 6.718-1.391 8.109S15.479 20.5 11 20.5c-4.478 0-6.718 0-8.109-1.391S1.5 15.479 1.5 11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F2D3D",
    strokeWidth: 1.5,
    d: "M15.5 11a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F2D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16.508 5.5h-.01"
  })));
};
export default SvgInstagram;